<template>
  <v-container>
    <v-card
    outlined
          v-ripple
          rounded
          class="mb-6"
          >
      <v-carousel
        continuous
        cycle
        :show-arrows="false"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        height="300"
      >
        <v-carousel-item
          v-for="(slider, i) in sliders"
          :key="i"
          :src="slider.image"
        >
        </v-carousel-item>
      </v-carousel>
    </v-card>

    <v-row>
      <v-col
        v-for="menu in menus"
        cols="6"
        :key="menu.title"
        sm="4"
        class=""
      >
        <v-card
          link
          :to="menu.path == '#' ? '' : menu.path"
          class="pa-5 text-center"
          outlined
          v-ripple
          rounded
        >
          <v-icon color="grey" x-large>{{ menu.icon }}</v-icon>
          <h5 class="font-weight-medium">{{ menu.title }}</h5>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      sliders: [],

      menus: [
        { title: "My Profile", icon: "mdi-account-settings", path: "/profile" },
        { title: "Directory", icon: "mdi-account-group", path: "/directory" },
        { title: "Products", icon: "mdi-view-list", path: "/products" },
        { title: "Shops", icon: "mdi-store-outline", path: "/shops" },
        { title: "Sales", icon: "mdi-shopping", path: "/sales" },
        {
          title: "Stock",
          icon: "mdi-briefcase-check-outline",
          path: "/stocks",
        },
      ],
    };
  },

  methods: {
    handleLogout() {
      this.$auth.logout();
      this.$router.push("/login");
    },
    loadSlider: function () {
      this.$api.getSlider().then((response) => {
        if (response.data.status == "success") {
          this.sliders = response.data.slider;
          console.log(this.sliders);
        } else {
          console.log("failed to load slider");
        }
      });
    },
  },
  beforeMount() {
    this.loadSlider();
  },
};
</script>
<style scoped>
h5 {
  margin-top: 10px;
  margin-bottom: 5px;
  color: #555;
}
</style>
